import { render } from "./BaseCropperOffcanvas.vue?vue&type=template&id=37661866&scoped=true"
import script from "./BaseCropperOffcanvas.vue?vue&type=script&lang=js"
export * from "./BaseCropperOffcanvas.vue?vue&type=script&lang=js"

import "./BaseCropperOffcanvas.vue?vue&type=style&index=0&id=37661866&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37661866"]])

export default __exports__